import { render, staticRenderFns } from "./registerMember.vue?vue&type=template&id=6d8356d2&scoped=true&"
import script from "./registerMember.vue?vue&type=script&lang=js&"
export * from "./registerMember.vue?vue&type=script&lang=js&"
import style0 from "./registerMember.vue?vue&type=style&index=0&id=6d8356d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8356d2",
  null
  
)

export default component.exports